import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';
import { Button, Modal, Space, message, Input, Table, Form } from 'antd';
import { ReloadOutlined, FolderOpenOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import CustomSelect from './CustomSelect';
import TableUser from './TableUser';
import FormUser from './FormUser';
import { OpenDialog, handleException, useHeighter, deleteRecord, waitRef, formitems } from './Utils';
import { hasRight } from './Login';
import axiosInstance from './axiosInstance';
/*
import Tabler from './Tabler.jsx'

const columns = [
  {
    title: 'A',
    dataIndex: 'a',
    width: 100,
	onCell: () => ({
      style: {
        maxWidth: 100,
        //whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }),
  },
  {
    title: 'B',
    dataIndex: 'b',
    width: 200,
	onCell: () => ({
      style: {
        maxWidth: 200,
        //whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }),
  },
  {
    title: 'C',
    dataIndex: 'c',
    width: 100,
	onCell: () => ({
      style: {
        maxWidth: 100,
        //whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }),
  },
  {
    title: 'D',
    dataIndex: 'd',
    width: 100,
	onCell: () => ({
      style: {
        maxWidth: 100,
        //whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }),
  },
  {}
];

const data = [
  { key: 1, a: 'AAA', b: 'BBB', c: 'CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC', d:'DDD DDDD DDD DDDD DDDD' },
  { key: 2, a: 'AAA', b: 'BBB', c: 'CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC', d:'DDD DDDD DDD DDDD DDDD' },
];

function TableTest() {
  const containerRef = useRef(null);	
  const tableRef = useRef(null);
  //const {columns:computedColumns} = useTableLastWidth(containerRef, columns);		
  return (
	//<div ref={containerRef}>
		<Tabler 
		tableLayout="fixed"
		//scroll={{x: 'max-content'}}
		columns={columns}
		dataSource={data}
		//pagination={false}
		/>
	//</div>
  );
}
*/

const FormUserSelection = forwardRef(({entity="TUser",...props},ref)=>{
    const [form] = Form.useForm();
    const url = '/dataservice'
    const cbFinish = useRef(null)
    
    useImperativeHandle(ref, () => ({
        open(cb=null) { cbFinish.current = cb }
    }))

    const items = [ 
        {name:"user", label:"Uživatel", required:true, ctrl: (pp)=>(<CustomSelect {...pp} url={url} scalar={true} postData={{entity:'VUser', cmd:'get-items'}}/>)}
    ]

    function handleFinish(values){
        if(cbFinish.current) cbFinish.current(values);
    };
    
    return (
        <div>
          <Form
              form={form}
              name={'userSelectionForm'}
              labelCol={{ span: 10 }}
              onFinish={handleFinish}
          >           
              {formitems(items,{},{},1)}
              <Form.Item wrapperCol={{ offset: 8, span: 24 }}>
                  <Button type="primary" htmlType="submit">Vybrat</Button> 
              </Form.Item>
          </Form>
        </div>
    )
})






function ModuleUser({visible=true}) {
	const [tableHeight] = useHeighter(300);
	const dlgRef = useRef(null);
	const tableRef = useRef(null);
	const formRef = useRef(null);
	const writeRight = hasRight('users','W');		
	const formRefSel = useRef(null);
  const dlgRefSel = useRef(null);

	const handleRefresh = () => { 
		tableRef.current.refresh()	
	}	
	const handleAdd = () => {  
		dlgRef.current.open()
		waitRef(formRef).then(()=>{formRef.current.open(0,handleRefresh)})	
	};
	const handleOpen = (e) => {
		dlgRef.current.open()
		waitRef(formRef).then(()=>{ formRef.current.open(tableRef.current.getSelectedRecid(),handleRefresh) }) 
	};	
	const handleDelete = async () => { 
		await deleteRecord('/userdelete',tableRef.current.getSelectedRecid())
		handleRefresh();		
	};

  const handleChangeLender = (e) => {
		dlgRefSel.current.open() 
    
		waitRef(formRefSel).then(()=>{ formRefSel.current.open(move) })
    async function move(values) {	
      dlgRefSel.current.close();
      try {
        const lenderfrom_id = tableRef.current.getSelectedRecid();
        const lenderto_id = values.user;
        await axiosInstance.post('/changelender', {lenderfrom_id, lenderto_id});
        message.success('Záznamy byly úspěšně převedeny');      
      } catch (err) { handleException(err)};
    } 
	};
	
	return (
		<div style={{ display: visible?'block':'none'}}>
			<h1>Uživatelé</h1>
			<div className="toolbar">
				<Space>
					<Button type="primary" icon={<ReloadOutlined/>} onClick={ handleRefresh} >Aktualizovat</Button>
					<Button icon={<FolderOpenOutlined/>} onClick={ handleOpen} >Otevřít</Button>
					<Button icon={<PlusOutlined/>} onClick={ handleAdd} disabled={!writeRight}>Přidat</Button>
					<Button icon={<DeleteOutlined/>} onClick={ handleDelete} disabled={!writeRight}>Odebrat</Button>
          <Button icon={<FolderOpenOutlined/>} onClick={ handleChangeLender} disabled={!writeRight}>Převést půjčky</Button>
				</Space>
				<Input.Search className="toolbar-search"placeholder="Hledat..." onSearch={(value) => tableRef.current.setSearchInput(value)} />
        	</div>
			<TableUser ref={tableRef} doubleClicked={handleOpen} scroll={{ y: tableHeight }}/>
			<OpenDialog width={500} title="Uživatel" Component={()=>(<FormUser writeRight={writeRight} ref={formRef}/>)} ref={dlgRef}/>
      <OpenDialog width={300} title="Cílový uživatel" Component={()=>(<FormUserSelection ref={formRefSel}/>)} ref={dlgRefSel}/>
    </div>
	);
};

export default ModuleUser;

